import {STATUS} from './helper';

export const initialState = (options) => {
    return {
        matching:options.matching || {},
        filterLookups: options.filterLookups || [],
        status:'pending',
        data: [],
        metricVideos: [],
        tags: []
    }
}

export const reducer = (state,action) =>{
    const {payload} = action;
    switch (action.type){
        case 'loading':
            return {...state,status:payload.loading}
        case 'addData':{
            // Add Initial Template Tags
            const templates = payload.data;
            const uniqueTags = [
            ...new Set(
                templates
                .filter(item => item.tags && item.tags.length > 0)
                .flatMap(item => item.tags)
            )
            ];
            state.tags = uniqueTags;
            state.data = payload.data;
            state.status = STATUS.READY;
            return {...state};
        }
        case 'addTemplate':{
            // Add Template Tags
            const tags = [...new Set([...state.tags, ...(payload.tags || [])])];
            state.tags = tags;
            state.data.push(payload);
            return {...state};
        }
        case 'editTemplate':{
            const templateUpdateIndex = state.data.findIndex((m)=> m.id === payload.id);
            if(templateUpdateIndex >= 0){
                // Update Template Tags
                const tags = [...new Set([...state.tags, ...(payload.tags || [])])];
                state.tags = tags;
                state.data[templateUpdateIndex] = payload;
            }
            return {...state};
        }
        case 'removeTemplate':
            const templateIndex = state.data.findIndex((m)=> m.id === payload.id);
            if(templateIndex >= 0){
                state.data.splice(templateIndex,1);
            }
            return { ...state };
        case 'addMetricVideo':
            state.metricVideos = payload.data;
            state.status = STATUS.READY;
            return {...state};
        default:
            return {...state};
    }
}